import { lazyLoad } from "$routes/_lib/lazy-load";
import { Route, Routes } from "react-router-dom";

const ClinicAdminControlPanel = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicAdmin" */
    "./chunk"
  ).then((module) => ({ default: module.default.ClinicAdminControlPanel })),
);

const FacilityReportsPage = lazyLoad(() =>
  import(
    /* webpackChunkName: "ClinicAdmin" */
    "./chunk"
  ).then((module) => ({ default: module.default.FacilityReportsPage })),
);

const BillingManagementPage = lazyLoad(() =>
  import(/* webpackChunkName: "ClinicAdmin" */ "./chunk").then((module) => ({
    default: module.default.BillingManagementPage,
  })),
);

export const ClinicAdminRoutes = () => (
  <Routes>
    <Route path="control-panel" element={<ClinicAdminControlPanel />} />
    <Route path="billing-management" element={<BillingManagementPage />} />
    <Route path="facility-reports" element={<FacilityReportsPage />} />
  </Routes>
);
